import 'setup/initialize-sentry';
import { PageErrorBoundary } from 'components/error-boundary';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import LoginRoute from 'routes/login/LoginRoute';
import { ThemeProvider } from 'utils/theme';

createRoot(document.getElementById('login-app')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <PageErrorBoundary>
          <LoginRoute />
        </PageErrorBoundary>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
